/**
 * Import own classes
 */
import loadJSON from '/src/modules/init/loadData';

const baseUrl = '/api/';

let storageService;

let storageArray = [];

/**
 * Set the storage service
 * @param {object} service
 */
export function setStorageService(service) {
  storageService = service;
}

/**
 * Class for API requests
 */
export class API {
  /**
   * @param {string} messeId
   * @param {string} quoteLineId
   */
  constructor(messeId, quoteLineId) {
    this.messeId = messeId;
    this.quoteLineId = quoteLineId;
    this.storageContent = null;
  }

  /**
   * Get Stammdaten for exhibitor according to this.quoteLineId
   * @return {*}
   */
  async getStammdatenByQuoteLineId() {
    if (this.quoteLineId !== null && this.quoteLineId !== '' && this.quoteLineId !== undefined) {
      this.storageContent = this.checkStorage();
      if (this.storageContent) {
        return this.storageContent;
      } else {

      }
    }
  }

  /**
   * @return {*}
   */
  checkStorage() {
    if (typeof(Storage) !== 'undefined') {
      return this.checkSessionStorage();
    } else if (Array.isArray(storageArray) && storageArray.length > 0) {
      return this.checkArrayStorage();
    }
    return false;
  }

  /**
   * @return {*}
   */
  checkSessionStorage() {
    if (sessionStorage.getItem(this.quoteLineId)) {
      let content = JSON.parse(sessionStorage.getItem(this.quoteLineId));
      if (this.isExpired(content[1])) {
        sessionStorage.removeItem(this.quoteLineId);
        return false;
      } else {
        return content[0];
      }
    }
  }

  /**
   */
  checkArrayStorage() {
    if (Array.isArray(storageArray) && storageArray.length > 0) {
      storageArray.forEach(this.findInStorageArray(storageItem, index, object));
    }
  }

  /**
   * @param {object} storageItem
   * @param {number} index
   * @param {object} object
   * @return {*}
   */
  findInStorageArray(storageItem, index, object) {
    if (Array.isArray(storageItem) && storageItem[0] === this.quoteLineId) {
      if (this.isExpired(storageItem[2])) {
        object.splice(index, 1);
        return false;
      } else {
        return JSON.parse(storageItem[1]);
      }
    }
  }

  /**
   * Check if lifetime of storageItem has expired or is unset
   * @param {object} storageItem
   * @return {boolean}
   */
  isExpired(storageItem) {
    if (Array.isArray(storageItem)) {
      if (typeof storageItem[1] !== 'undefined' || storageItem[1] < (Date.now() - 300000)) {
        return true;
      }
    }
    return false;
  }
}

/**
 * Get Stammdaten for exhibitor according to quoteLineId
 * @param {string} messeId The id of the exhibition
 * @param {string} quoteLineId The id of the booth
 * @return {Promise<void>|bool} Either a promise or false
 */
export async function getStammdatenByQuoteLineId(messeId, quoteLineId) {
  const regexPattern = new RegExp('^([a-zA-Z0-9])\\1{2,}$', 'g');
  if (quoteLineId !== null && quoteLineId !== '' && quoteLineId !== undefined && !regexPattern.test(quoteLineId) ) {
    let storageContent = checkStorage(quoteLineId);
    if (storageContent !== false) {
      return storageContent;
    } else {
      try {
        let result = await loadJSON(baseUrl + 'quoteline/' + messeId + '/' + quoteLineId);

        if (result !== undefined) {
          writeIntoStorage(quoteLineId, result);

          return result;
        } else {
          console.log('Kann keine Informationen abrufen');
          return false;
        }
      } catch (e) {
        return e.message;
      }
    }
  } else {
    return false;
  }
}

/**
 * Save request result locally in session storage or, if not available, in an array (for older browsers not supporting web storage)
 * @param {string} quoteLineId
 * @return {*}
 */
function checkStorage(quoteLineId) {
  if (typeof(Storage) !== 'undefined') {
    if (sessionStorage.getItem(quoteLineId)) {
      let content = JSON.parse(sessionStorage.getItem(quoteLineId));
      if (typeof content[1] === 'undefined' || content[1] < (Date.now() - 300000)) {
        sessionStorage.removeItem(quoteLineId);
        return false;
      } else {
        return content[0];
      }
    } else {
      return false;
    }
  } else {
    if (Array.isArray(storageArray) && storageArray.length > 0) {
      storageArray.forEach((storageItem, index, object) => {
        if (Array.isArray(storageItem) && storageItem[0] === quoteLineId) {
          if (typeof storageItem[2] === 'undefined' || storageItem[2] < (Date.now() - 300000)) {
            object.splice(index, 1);
            return false;
          } else {
            return JSON.parse(storageItem[1]);
          }
        } else {
          return false;
        }
      });
    } else {
      return false;
    }
  }
}

/**
 * Write request result locally
 * @param {string} quoteLineId
 * @param {*} content
 * @return {boolean}
 */
function writeIntoStorage(quoteLineId, content) {
  let contentArray = [];

  if (typeof content.error === 'undefined') {
    if (typeof(Storage) !== 'undefined') {
      if (content.length > 0) {
        contentArray.push(content);
        contentArray.push(Date.now());
        sessionStorage.setItem(quoteLineId, JSON.stringify(contentArray));
      }
    } else {
      if (content.length > 0) {
        let newStorageItem = [quoteLineId, JSON.stringify(content), Date.now()];
        storageArray.push(newStorageItem);
      }
    }
  } else {
    return false;
  }
}
